export default __webpack_public_path__ + "static/media/tooltipimg.80f73980.svg";